import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {SetInit} from '@shared/state/auth/auth.actions';
import {Select, Store} from '@ngxs/store';
import {AuthState} from '@shared/state/auth/auth.state';
import {map, take} from 'rxjs/operators';
import {isAnon} from '@shared/helpers/auth';
import {RoutingService} from '@app/service/routing/routing.service';
import {StorageService} from '../service/util/storage.service';
import {PROVIDER_DATA_KEY} from '@shared/helpers/variables';
import {UserInfo} from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard  {
  @Select(AuthState.getProviderData) providerData$: Observable<UserInfo[] | null>;
  @Select(AuthState.getUserToken) userToken$: Observable<string>;

  constructor(private store: Store, private routingService: RoutingService, private storageService: StorageService) {
  }

  /**
   * Guard that allows users that are either not authenticated or are anonymous
   * Check to see if there is provider data, if no provider data, they are not auth so show the no auth screen
   * @param next
   * @param state
   */
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    this.store.dispatch(new SetInit({canNavigate: false}));

    return this.storageService.observeValue(PROVIDER_DATA_KEY).pipe(
      take(1),
      map((providerData: UserInfo[] | undefined) => {
        if (!providerData) {
          return true;
        }
        for (const data of providerData) {
          // If it's anon, especially in auth situations, allow the user to perform auth actions
          if (isAnon(data.providerId)) {
            return true;
          }
        }
        if (this.isAuth(state.url)) {
          this.routingService.navigateHome();
          return;
        }
        return true;
      })
    );
  }

  isAuth(url: string): boolean {
    return url.includes('/login') || url.includes('/register') || url.includes('/forgot-password');
  }
}
